import { memo } from 'react';
import { Container, SpaceBetween } from '@amzn/awsui-components-core';

import { useEntities } from '../v2-hooks/useEntities';
import {
  longTitleInputMaxLength,
  longTitleInputMinLength,
  shortTitleInputMaxLength,
  shortTitleInputMinLength,
} from '../../api/UtilsApi';
import { useContentTitleHeadingViewModel } from './ContentTitleHeadingViewModel';
import TitleFieldView from './TitleFieldView';

function ContentTitleHeadingView() {
  const vm = useContentTitleHeadingViewModel();
  const entities = useEntities();

  if (!vm) return null;

  return (
    <Container>
      <SpaceBetween size="l">
        <TitleFieldView
          label="Long title"
          description="Enter a long title. This title appears as the page title."
          vm={vm.longTitle}
          min={longTitleInputMinLength}
          max={longTitleInputMaxLength}
          entities={entities}
          testId="edit-content-long-title"
        />
        <TitleFieldView
          label="Short title"
          description="Enter a short title. This title appears on the home page card and search experiences."
          vm={vm.shortTitle}
          min={shortTitleInputMinLength}
          max={shortTitleInputMaxLength}
          entities={entities}
          showDuplicateCheck={false}
          testId="edit-content-short-title"
        />
      </SpaceBetween>
    </Container>
  );
}

export default memo(ContentTitleHeadingView);
